(() => {
  if (window.variantModelPlacementInitialized) return;
  window.variantModelPlacementInitialized = true;

  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const resetViewerFraming = (viewer) => {
    if (!viewer) return;
    const cameraOrbit = viewer.dataset.initialCameraOrbit;
    const fieldOfView = viewer.dataset.initialFieldOfView;
    if (cameraOrbit) viewer.setAttribute('camera-orbit', cameraOrbit);
    if (fieldOfView) viewer.setAttribute('field-of-view', fieldOfView);
    if (typeof viewer.jumpCameraToGoal === 'function') viewer.jumpCameraToGoal();
  };

  const initializeViewerFraming = (viewer) => {
    if (!viewer || viewer.dataset.framingInitialized === 'true') return;
    viewer.dataset.framingInitialized = 'true';
    resetViewerFraming(viewer);
    viewer.addEventListener('load', () => resetViewerFraming(viewer), { once: true });
  };

  const placeVariantModels = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      // Shopify replaces the variant-model wrapper when an option changes. The
      // frames are intentionally moved outside that wrapper, so an older frame
      // can otherwise survive the replacement and continue showing the prior
      // SKU. A model that still owns its frames is the newly rendered one.
      const model = [...productInfo.querySelectorAll('.variant-model')].find(
        (candidate) => candidate.querySelector('.variant-model__product-frame, .variant-model__comparison, .variant-model__development-status'),
      );
      const productFrame = model?.querySelector('.variant-model__product-frame')
        || productInfo.querySelector('.variant-model__product-frame');
      const comparisonFrame = model?.querySelector('.variant-model__comparison')
        || productInfo.querySelector('.variant-model__comparison');
      // Exact-variant status: a new model must not inherit a moved sibling notice.
      const statusFrame = model
        ? model.querySelector('.variant-model__development-status')
        : productInfo.querySelector('.variant-model__development-status');
      const desktopAnchor = productInfo.querySelector('[data-variant-model-desktop-anchor]');
      const mobileAnchor = productInfo.querySelector('[data-variant-model-mobile-anchor]');
      const currentModel = productInfo.querySelector('.variant-model');
      const hasModel = currentModel?.dataset.hasModel === 'true';
      const product = productInfo.querySelector('.product:has(> .product__3d-wrapper)');
      const desktopColumn = product?.querySelector(':scope > .product__3d-wrapper');

      product?.classList.toggle('product--variant-model-unavailable', !hasModel);
      if (desktopColumn) desktopColumn.hidden = !hasModel;

      // Fail closed. When Shopify renders an unsupported exact SKU, its new
      // wrapper contains no frames. Remove any frames moved out of the prior
      // wrapper so a sibling variant can never inherit a stale model.
      if (!hasModel) {
        productInfo.querySelectorAll('.variant-model__product-frame, .variant-model__comparison').forEach((frame) => frame.remove());
        productInfo.querySelectorAll('.variant-model__development-status').forEach((frame) => {
          if (frame !== statusFrame) frame.remove();
        });
        const statusTarget = mobileAnchor;
        if (statusFrame && statusTarget) {
          if (statusFrame.parentElement !== statusTarget) statusTarget.appendChild(statusFrame);
        } else {
          productInfo.querySelectorAll('.variant-model__development-status').forEach((frame) => frame.remove());
        }
        return;
      }

      if (!productFrame || !comparisonFrame || !mobileAnchor) return;

      initializeViewerFraming(productFrame.querySelector('model-viewer'));

      if (model) {
        productInfo.querySelectorAll('.variant-model__product-frame, .variant-model__comparison, .variant-model__development-status').forEach((frame) => {
          if (frame !== productFrame && frame !== comparisonFrame && frame !== statusFrame) frame.remove();
        });
      }

      // Bold draft: use the same exact frames inside gallery disclosures.
      const boldProduct = productInfo.querySelector('[data-bold-view="product"]');
      const boldHand = productInfo.querySelector('[data-bold-view="hand"]');
      if (productInfo.hasAttribute('data-bold-layout-draft') && boldProduct && boldHand) {
        if (productFrame.parentElement !== boldProduct) boldProduct.append(productFrame);
        if (comparisonFrame.parentElement !== boldHand) boldHand.append(comparisonFrame);
        if (statusFrame && statusFrame.parentElement !== boldProduct) boldProduct.append(statusFrame);
        return;
      }
      const targetAnchor = desktopQuery.matches && desktopAnchor ? desktopAnchor : mobileAnchor;
      if (!targetAnchor) return;

      // Desktop uses a true third product-page column. Tablet and mobile move
      // the complete product-and-hand review into normal selector flow.
      if (desktopQuery.matches && desktopAnchor) {
        if (productFrame.parentElement !== desktopAnchor) desktopAnchor.appendChild(productFrame);
      } else if (productFrame.parentElement !== targetAnchor) {
        targetAnchor.appendChild(productFrame);
      }
      if (comparisonFrame.parentElement !== targetAnchor) targetAnchor.appendChild(comparisonFrame);
      if (statusFrame && statusFrame.parentElement !== targetAnchor) targetAnchor.appendChild(statusFrame);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeVariantModels, { once: true });
  } else {
    placeVariantModels();
  }

  desktopQuery.addEventListener('change', placeVariantModels);
  document.addEventListener('shopify:section:load', placeVariantModels);
  document.addEventListener('product-info:loaded', placeVariantModels);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.variant-model__viewer').forEach(resetViewerFraming);
  });

  new MutationObserver(placeVariantModels).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-has-model'],
    childList: true,
    subtree: true,
  });
})();
